export const COUNTRY = '/country/'
export const COUNTRY_ALL = `${COUNTRY}all`
